export const FONT_FAMILY_KEY = 'ff';
export const LIKED_VIDEOS_KEY = 'lv';

export const validStorageKeys = [FONT_FAMILY_KEY, LIKED_VIDEOS_KEY];

export const storeKey = '_watch_settings_';
